// observe sidebar-driven navigation (history.pushState) and re-render.

const CRY_NAV_EVENT = 'cry-nav-change';
let installed = false;

/**
 * Patch history.pushState/replaceState (idempotent) to dispatch a custom event.
 *
 * calc-sidebar's SidebarNav activates items via `history.pushState`, which fires
 * no native event. Without this patch, shell chrome that derives state from the
 * URL hash (e.g. the Header settings-gear active indicator) would not update
 * after a sidebar click. The patch dispatches a `cry-nav-change` event that
 * `useSyncNavActive` subscribes to.
 */
export function installNavHashSync(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const wrap = (method: 'pushState' | 'replaceState') => {
    const original = history[method];
    history[method] = function (...args: Parameters<typeof original>) {
      const ret = original.apply(this, args);
      window.dispatchEvent(new Event(CRY_NAV_EVENT));
      return ret;
    };
  };

  wrap('pushState');
  wrap('replaceState');
}

/** Subscribe a listener to any navigation change (sidebar pushState + popstate + hashchange). */
export function onNavChange(listener: () => void): () => void {
  window.addEventListener(CRY_NAV_EVENT, listener);
  window.addEventListener('popstate', listener);
  window.addEventListener('hashchange', listener);
  return () => {
    window.removeEventListener(CRY_NAV_EVENT, listener);
    window.removeEventListener('popstate', listener);
    window.removeEventListener('hashchange', listener);
  };
}
